import {FilterDirective} from './container/filter.directive';

export abstract class FilterFieldAbstract {

    protected abstract filter: FilterDirective;

    get verticalAlignment(): boolean {
        return this.filter.verticalAlignment;
    }

    get colClass(): string {
        return `col-xs-${this.filter.columns}`
    }

    getFormGroupClasses() {
        return {
            [this.colClass]: true,
            'vertical-form-group': this.verticalAlignment
        };
    }

    getFormLabelClasses() {
        return {
            'control-label': true,
            'col-xs-4     ': !this.verticalAlignment
        };
    }

    getFormControlClasses() {
        return {
            'col-xs-8': !this.verticalAlignment
        };
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/shared/filter/filter-field.abstract.ts